import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';

import { AuthService } from '../../services/http/auth/auth.service';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !this.authService.isLoggedIn;
  }
}
